<template>
	<div class="contein flex" style="height: 720px;overflow: hidden;  position: relative" @click="opencamra()" v-loading="videoLoaing">
		<!-- {{ compnum }} bao-->
		<div style="overflow: hidden; flex: 1;position: relative;">
			<div
				class="canvas"
				id="canpic"
				ref="can3"
				:style="{
					transform: 'scale(' + num + ')',
					position: 'absolute',
					width: '100%',
				}"
				@mousewheel="suo"
				@mousedown.stop="moveMouse"
				v-if="dwImg"
			>
				<!-- <AIMarker
        ref="aiPanelEditor"
        :readOnly="true"
        :img-url="dwImg"
        @vmarker:onReady="ready"
        @vmarker:onAnnoAdded='added'
      ></AIMarker> -->
				<crtmarker ref="aiPanelEditor" @added="added" :isBZ="true" :imgUrl="dwImg" v-if="dwImg" />
			</div>
		</div>
		<div style="width: 300px; border: 1px groove; height: 100%; overflow: auto" v-if="comara">
			<div class="center" style="background: none">
				<!-- <h3 style="background: none">{{ videoName }}视频列表</h3> -->
			</div>

			<div v-if="videoList.length !== 0" style="height: 98%; width: 100%;" class="mt20">
				<div v-for="(item, index) in videoList" :key="index" class="mt20">
					<!-- <div> -->
					<div class="selectVideo">
						<cus-player @click="clickPlayer(index)" :ref="'video' + index" :id="'video' + index" v-if="item.name !== '海康萤石云'"></cus-player>
						<iframe height="100%" allowfullscreen width="100%" :src="'https://open.ys7.com/ezopen/h5/iframe?url=' + item.content" v-else frameborder="0"></iframe>
					</div>
					<div class="ml10">
						<h4>
							点位位置:<span class="ml10" style="font-weight: normal">{{ item.trueName }}</span>
						</h4>

						<h4>
							视频位置:<span class="ml10" style="font-weight: normal">{{ item.address }}</span>
						</h4>
						<h4>
							视频ip:
							<span class="ml10" style="font-weight: normal">{{ item.ip }}</span>
						</h4>
						<div class="center mt10"></div>
					</div>
					<!-- </div> -->
				</div>
			</div>
			<div class="center" style="height: 32%; width: 100%;background:#000;color:#fff;border" v-if="videoList.length == 0">
				<span>暂无数据</span>
			</div>
		</div>
	</div>
</template>

<script>
	import crtmarker from "../components/crtmarker";
	import CusPlayer from "../components/CusPlayer.vue";

	import "xgplayer";
	import FlvJsPlayer from "xgplayer-flv.js";
	import config from "../utils/config.js";

	export default {
		data() {
			return {
				isdraged: false,
				dwImg: "",
				videoLoaing: false,
				num: 1,
				comara: false,
				videoAddr: "",
				videoName: "",
				pointArr: [],
				videoList: [], // 摄像头
				videoIndex: 0,
			};
		},
		components: {
			crtmarker,
			CusPlayer,
		},
		props: ["compnum", "nowtime", "companyNum", "idx"],
		created() {
			this.getList();
		},
		mounted() {},
		methods: {
			// 获取萤石云
			// getYSY(id) {
			//   console.log(id);
			// },
			added(v) {
				// console.log(v, 11);
				this.clickPlayer();
			},
			opencamra(it) {
				log(it);
				// console.log(it);
				// if (it === this.videoName) {
				//   this.$message.warning('该点位已展示');
				// }

				this.videoName = it?.trueName;

				// this.videoList = []; // 清空摄像头
				if (it?.tag) {
					var request = true;
					this.videoList.map((item) => {
						console.log(item, "request");
						if (item.number === it.tag) {
							request = false;
						}
					});
					setTimeout(() => {
						if (request) {
							this.getPointer();
							this.$post("/crt/crtselectip", { v_video_number: it.tag, c_number: this.compnum.c_number }).then((res) => {
								if (res.data) {
									// 限制之前的视频是否能点击
									this.comara = true;
									var arr = res.data.video;
									// var videoList = this.videoList;
									//  videoList.push({iframe:'https://www.baidu.com',address:'测试',ip:'123.133.13.133'})
									if (this.videoList.length >= 4) {
										this.videoList.splice(this.videoList.length - 1, 1);
									}
									this.$post("/crt/videoaddress", {
										video_ip: arr[0].ip,
										type: 1,
										companyNum: res.data.companyNum,
									}).then((RES) => {
										// console.log(RES, 'get isolly');
										if (RES.code == 200) {
											if (RES.isonly == 1) {
												// this.getYSY(arr[0].ip);
												this.$get("basevideo/videotoken").then((Res) => {
													if (Res.code == 200) {
														var url = `ezopen://open.ys7.com/${arr[0].ip}/1.live&accessToken=${Res.data}`;
														this.videoList.push({
															content: url,
															address: arr[0].address,
															ip: arr[0].ip,
															trueName: it.trueName,
															number: it.tag,
															isPlay: false,
															name: RES.name,
															webUrl: arr[0].url || "",
														});
													}
												});
											} else {
												this.videoList.push({
													content: RES.data,
													address: arr[0].address,
													ip: arr[0].ip,
													trueName: it.trueName,
													number: it.tag,
													isPlay: false,
													name: RES.name,
													webUrl: arr[0].url || "",
												});
											}
										} else {
											this.$message.warning(`${arr[0].ip}设备不存在！`);
										}
										//  this.videoList = videoList
									});
									this.comara = true;
									this.videoLoaing = false;

									setTimeout(() => {
										if (this.videoList[this.videoList.length - 1].content) {
											this.clickPlayer(this.videoList.length - 1);
										}
									}, 500);
								} else {
									this.$message.warning("该点位未绑定摄像头！");
									this.comara = true;
									this.videoLoaing = false;
								}
							});
						}
					}, 700);
				}
				// this.getVideo(it);
			},
			//获取萤石云摄像头
			reset() {
				this.isdraged = false;

				this.dwImg = "";
				this.videoAddr = "";
				this.videoName = "";
				this.pointArr = [];
				this.videoList = []; // 摄像头
			},
			getList() {
				this.pointArr = [];
				var arr = [];
				setTimeout(() => {
					this.$post("crt/crtselect", this.compnum).then((res) => {
						/**
						 *  data[0]:报警的点位图及点位，闪动的点位
						 *  data[1]:闪动的摄像头信息
						 *  data[2]:该点位图下绑定的其他点位位置
						 */
						// log(res, '点位信息');
						if (res.data.length && res.data[0].area_uuid) {
							var obj1 = res.data[0];
							this.dwImg = res.data[0].image;
							this.videoAddr = obj1.device_name;
							var obj = {
								tag: obj1.number,
								tagName: `<div>部位编号：${obj1.number}<br/>
                             部位名称：${obj1.true_addr}
                        </div> `,

								trueName: obj1.true_addr,
								x: obj1.x_axis,
								y: obj1.y_axis,
								type: obj1.point_type,
								point_uuid: obj1.point_uuid,
							};
							arr.push(obj);

							res.data[2].map((item) => {
								if (item.point_uuid !== res.data[0].point_uuid) {
									var obj2 = {
										tag: item.number,
										tagName: `<div>部位编号：${item.number}<br/>
                                 部位名称：${item.true_addr}
                            </div>
                          `,
										trueName: item.true_addr,
										x: item.x_axis,
										y: item.y_axis,
										type: item.point_type,
										point_uuid: item.point_uuid,
										arrow_remark: item.arrow_remark, // 摄像头方向
									};
									arr.push(obj2);
								}
							});

							res.data[1].map((item) => {
								if (item.point_uuid !== res.data[0].point_uuid) {
									var obj2 = {
										tag: item.number,
										tagName: `<div>部位编号：${item.number}<br/>
                                 部位名称：${item.true_addr}
                            </div>
                          `,
										trueName: item.true_addr,
										x: item.x_axis,
										y: item.y_axis,
										type: item.point_type,
										point_uuid: item.point_uuid,
									};
									arr.push(obj2);
								}
							});

							this.opencamra(arr[0]);
							this.pointArr = arr;
						} else {
							this.$message.warning("该区域无点位标注，请联系管理员");
							this.dwImg = "";
						}
					});
				}, 700);
			},
			clickPlayer(index) {
				this.videoIndex = index ? index : 0;
				var url = this.videoList[index].content;
				if (url.indexOf("ezopen") > -1) {
					url = url;
				} else {
					url = `${this.videoList[index].webUrl ? this.videoList[index].webUrl + "/live" : config.camraWs}?url=${this.videoList[index].content}`;
					//  'ws://192.168.0.251:8866/live?url=192.168.1.1'
				}
				this.playUrl = url;
				this.handlePlay();
			},
			handlePlay() {
				if (this.videoList[this.videoIndex].isPlay == false) {
					if (this.playUrl) {
						let ref = "video" + this.videoIndex;
						setTimeout(() => {
							this.$refs[ref][0].createPlayer(this.playUrl, false, this.videoIndex);
							this.videoList[this.videoIndex].isPlay = true;
						}, 10);
						// this.$refs[ref].createPlayer(this.playUrl, true, this.videoIndex);
					} else {
						this.$message.error("请填写播放地址");
					}
				}
			},
			getPointer() {
				// this.remove();
				if (!this.$refs["aiPanelEditor"]) return;
				else this.$refs["aiPanelEditor"].remove();

				this.$refs["aiPanelEditor"].getBiaozhu(this.pointArr);
				if (this.pointArr.length && this.pointArr[0].x && this.pointArr[0].y) {
					// console.log(this.pointArr[0].x, 'set pointArr to x');
					console.log((document.getElementsByClassName("marker")[0].className += " animate"));

					document.getElementsByClassName("marker")[0].className += " animate";
					this.Lister();
				}

				// console.log(this.$refs['aiPanelEditor']);
			},
			ready() {
				this.$refs["aiPanelEditor"].getMarker().clearData();
			},
			Lister() {
				var _this = this;
				setTimeout(() => {
					var div = document.getElementById("canpic");
					var divs = document.getElementsByClassName("marker");

					var element = Array.from(divs);
					// log(element);
					for (var i = 0; i < element.length; i++) {
						divs[i].onclick = function() {
							// 获取点击的 点位编号
							var id = element[element.indexOf(this)].id;

							var it = _this.pointArr.find((item) => {
								return item.point_uuid === id;
							});
							_this.opencamra(it);
						};
					}
				}, 200);
			},
			suo(v) {
				this.num -= -((v.wheelDelta ? v.wheelDelta : v.deltaY) / 1000);
				if (this.num < 0) {
					this.num = 0.1;
				}
			},
			moveMouse(event) {
				var ooid = this.$refs.can3; //获取目标元素
				var dx = event.clientX - ooid.offsetLeft;
				var dy = event.clientY - ooid.offsetTop;
				ooid.onmousemove = (event) => {
					// console.log(event, 'move cursor to position');
					event = event || window.event;

					var left = event.clientX;
					var top = event.clientY;

					ooid.style.left = left - dx + "px";
					ooid.style.top = top - dy + "px";
				};
				ooid.onmouseup = () => {
					ooid.onmousemove = null;
					ooid.onmouseup = null;
				};
				ooid.onmouseout = () => {
					ooid.onmousemove = null;
					ooid.onmouseup = null;
				};
			},
			getPoint(arr) {
				this.$refs["aiPanelEditor"].getMarker().clearData();
				this.$refs["aiPanelEditor"].getMarker().renderData(arr);
			},
		},
		watch: {
			compnum: function(v) {
				this.comara = false;
				this.videoList = [];
				this.getList();
			},
			comara(val) {
				setTimeout(() => {
					// console.log(val, "listen comara");
					this.getPointer();
				}, 20);
			},
		},
	};
</script>
<style></style>
<style scoped>
	.selectVideo {
		border: solid 1px red;
		height: 200px;
		width: 299px;
		position: relative;
	}
	::v-deep .selected {
		z-index: 99999;
	}
	::v-deep .g-image-op {
		background: #fff;

		border: 1px solid #ccc;
		bottom: 110%;
	}
	::v-deep .g-image-op-del {
		display: none;
	}
	::v-deep .g-image-op-content {
		height: auto;
	}

	::v-deep .animate {
		width: 20px;
		height: 20px;
		animation: warningmove 0.6s infinite;
		position: absolute !important;
		/* z-index: 999999; */
	}

	@keyframes warningmove {
		from {
			background: yellow;
		}
		to {
			background: #ed1c24;
		}
	}
</style>
